/**
 * Store user module.
 *
 * @module store/user/module
 * @author Dilan Useche <dilan8810@gmail.com>
 * */

import actions from './user.actions';

/**
 * export default
 *  @type {VuexModule}
 * */
export default {
  namespaced: true,
  actions,
};
